export default __webpack_public_path__ + "static/media/medium.e80af9c5.png";